import TopBar from "../../../components/LayoutComponent/TopBar/topBar";
import Tabbar from "../../../components/LayoutComponent/TabBar/Tabbar";
import HomeTopCard from "../../../components/HomeComponents/HomeTopCard";
import "../userDashboard.css";
import TagSearchPage from "../../../components/BookComponents/TagSearch";

export const UserTagSearchPage = () => {
  return (
    <>
      <div className="w3-content" style={{ minHeight: "400px" }}>
        <TopBar
          showBackButton
          displayType="logo"
          showNotification
          showProfileBtn
        ></TopBar>
        <TagSearchPage></TagSearchPage>
        <Tabbar menuType={"users"}></Tabbar>
      </div>
    </>
  );
};

export default UserTagSearchPage;
